import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import AdminMode from './components/AdminMode';
import MatchdaySplash from './components/MatchdaySplash';
import HomePage from './pages/HomePage';
import HistoryPage from './pages/HistoryPage';
import StandingsPage from './pages/StandingsPage';
import SquadPage from './pages/SquadPage';
import { storage } from './utils/storage';
import './App.css';

function AppContent() {
  const [, setIsAdmin] = useState(storage.isAdminMode());
  const location = useLocation();
  const isHistoryPage = location.pathname === '/gecmis';

  useEffect(() => {
    // Uygulama başlığını her zaman "LONCA APP" olarak ayarla
    document.title = 'LONCA APP';
    
    // Cache'i başlat
    storage.initializeCache();
    
    // Favicon'u yükle (admin panelden ayarlanmışsa)
    const loadFavicon = async () => {
      try {
        const settings = await storage.getAdminSettings();
        if (settings.faviconUrl) {
          // Mevcut favicon linkini bul veya oluştur
          let faviconLink = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
          if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            document.head.appendChild(faviconLink);
          }
          faviconLink.href = settings.faviconUrl;
          console.log('[App] Favicon güncellendi:', settings.faviconUrl);
        }
      } catch (error) {
        console.error('[App] Favicon yükleme hatası:', error);
      }
    };
    
    loadFavicon();
  }, []);

  return (
    <div className="App">
      <MatchdaySplash />
      {isHistoryPage && <AdminMode onToggle={setIsAdmin} showLockButton={true} />}
      {!isHistoryPage && <AdminMode onToggle={setIsAdmin} showLockButton={false} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gecmis" element={<HistoryPage />} />
        <Route path="/puan-durumu" element={<StandingsPage />} />
        <Route path="/kadro" element={<SquadPage />} />
      </Routes>
      <Navigation />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;



